export const SANS_SERIF = { label: '活字体', value: 'Verdana, Arial, Helvetica, sans-serif', imageUrl: '/embroidery/font/sansSerif.jpg' } //ゴシック体
export const CURSIVE = {
  label: '筆記体',
  value: 'cursive, Pacifico, Quicksand, Lobster, Shadows Into Light, Attraction, Dancing Script, Allura, Tangerine',
  imageUrl: '/embroidery/font/cursive.jpg'
} // 筆記体
export const SERIF = { label: '漢字', value: '游明朝, Yu Mincho,YuMincho, Hiragino Mincho Pro,serif', imageUrl: '/embroidery/font/serif.jpg' } // 明朝体

// 刺繍位置
export const THUMB_LABEL = 'Thumb'
export const PINKY_LABEL = 'Pinky'
export const LITTLE_LABEL = 'Little'
export const PINKY_SIDE_BACK_LABEL = 'Pinky side back'
export const LEATHER_LINING_FIRST_LABEL = 'Palm liner (1 step)'
export const LEATHER_LINING_SECOND_LABEL = 'Palm liner (2 step)'

// 刺繍カラー
export const NONE_LABEL = 'None'
export const GOLD_LABEL = 'Gold'
export const SILVER_LABEL = 'Silver'
export const LIGHT_GOLD_LABEL = 'Light Gold'
export const LIGHT_SILVER_LABEL = 'Light Silver'
export const CORK_LABEL = 'Cork'
export const CHOCOLATE_LABEL = 'Chocolate'
export const YELLOW_LABEL = 'Yellow'
export const LEMON_YELLOW_LABEL = 'Lemon Yellow'
export const ORANGE_LABEL = 'Orange'
export const RED_LABEL = 'Red'
export const PINK_LABEL = 'Pink'
export const PURPLE_LABEL = 'Purple'
export const GREEN_LABEL = 'Green'
export const SKY_BLUE_LABEL = 'Sky Blue'
export const BLUE_LABEL = 'Blue'
export const NAVY_LABEL = 'Navy'
export const BLACK_LABEL = 'Black'
export const WHITE_LABEL = 'White'

// フォント
export const CURSIVE_LABEL = 'Cursive'
export const SANS_SERIF_LABEL = 'Gothic'
export const SERIF_LABEL = 'Kanji(block style)'
